var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.167 6.1C12.627 3.68 10.374 2.287 8 2.287c-1.186 0-2.34.346-3.393.993-1.053.653-2 1.607-2.774 2.82-.666 1.047-.666 2.747 0 3.793C3.374 12.32 5.627 13.707 8 13.707c1.187 0 2.34-.347 3.393-.994 1.054-.653 2-1.606 2.774-2.82.667-1.04.667-2.746 0-3.793M8 10.693A2.69 2.69 0 0 1 5.307 8 2.69 2.69 0 0 1 8 5.307 2.69 2.69 0 0 1 10.694 8 2.69 2.69 0 0 1 8 10.693"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 6.093A1.903 1.903 0 0 0 8 9.9 1.91 1.91 0 0 0 9.907 8c0-1.047-.86-1.907-1.907-1.907"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeActive);
export default __webpack_public_path__ + "static/media/eyeActive.fb307b9ba551e78c5b6d08940ea9b714.svg";
export { ForwardRef as ReactComponent };